export const SET_ROLE = 'SET_ROLE';
export const CLIENT_ROLE = 'CLIENT_ROLE';
export const ADMIN_ROLE = 'ADMIN_ROLE';
